module.exports = __webpack_public_path__ + "img/select-up-circle.9552f3c0.png";